import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoLibroPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoLibroPage",
            ss: ss,
            ajax: {
                "url": ss.indexTipoLibro(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N°', orderable: false, searchable: false },
                { data: 'TipoLibro', name: 'TipoLibro', title: 'Tipo' },
                // { data: 'Descripcion', name: 'Descripcion', title: 'Descripción' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            tipolibros: [],
            tipolibro: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipoLibro() {
            this.tipolibro = {};
            this.$refs['frm-tipolibro'].show();
        },
        showTipoLibro(id) {
            this.isLoading=true;
            this.ss.showTipoLibro(id).then(
                (result) => {
                    let response = result.data;
                    this.tipolibro = response.data;
                    this.$refs['view-tipolibro'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoLibro() {
            this.$refs['frm-tipolibro'].show();
            this.$refs['view-tipolibro'].hide();
        },
        cancelTipoLibro() {
            if (this.tipolibro.id) {
                this.$refs['view-tipolibro'].show();
            }
            this.$refs['frm-tipolibro'].hide();
        },
        saveTipoLibro() {
            this.ss.storeTipoLibro(this.tipolibro).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipolibro'].hide();
                    this.$refs['datatable-tipolibro'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoLibro() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyTipoLibro(this.tipolibro)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipolibro'].hide();
                                this.$refs['datatable-tipolibro'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoLibro').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoLibro(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
